export const VERSION = require('../package.json').version;
export const PARAM_NAME = 'sznclid';
export const PARAM_CONSENT_NAME = 'consent';
export const ACTIONS = {
  NOT_STORED: 'notstored',
  SAME: 'same',
  DIFFERENT: 'different',
  NO_CONSENT: 'noconsent',
};
export const HIT_TARGET = 'https://h.seznam.cz/hit';
export const HIT_ACTIONS = {
  CMPONE: 'cmpone',
  RCCONSENT: 'rcconsent',
  IABCONSENT: 'iabconsent',
};
export const SID_COOKIE_NAME = 'sid';
export const DEBUG_CONFIG = {
  bColor: '#4b0082',
  fColor: '#fff',
  name: 'linkdec',
};
export const SCMP_SSP_INTERNAL = 'scmp_sspServerData';
export const SCMP_SSP_EVENT = 'cmpdatareceived';
// How long to look for consent in ms
export const CONSENT_DETECTION_TIMEOUT = 5000;
export const CONSENT_DETECTION_INTERVAL = 500;
export const CONSENT_BLACKLIST = ['echo24.cz'];
export const SID_BLACKLIST = ['echo24.cz'];
